const menus = [
    {
        id: 1,
        name: 'STAKING',
        links: '#',
        disabled: 'disable',
    },
    {
        id: 2,
        name: 'STABILISING',
        links: '#',
        disabled: 'disable',
    },
    {
        id: 3,
        name: 'FORGE',
        links: '#',
        disabled: 'disable',
    },
    {
        id: 4,
        name: 'SUMMON',
        links: '#',
        disabled: 'disable',
    },
    {
        id: 5,
        name: 'CLAIMING',
        links: 'claiming',
    },
    
]

export default menus;